<template>
  <v-navigation-drawer
    right
    clipped
    app
    mobile-breakpoint="960"
    v-model="drawer"
    disable-route-watcher
    disable-resize-watcher>
    <v-card dark height="100%">
      <v-card-title class="pl-6 pr-1">
        <span>즐겨찾기</span>
        <v-spacer/>
        <v-btn icon dark @click="drawer = false" v-if="$vuetify.breakpoint.smAndDown">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-actions class="py-0 justify-end">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small icon v-on="on" @click="editBookMarkMenu"><v-icon x-small color="white">mdi-square-edit-outline</v-icon></v-btn>
          </template>
          <span>편집</span>
        </v-tooltip>
        <v-tooltip bottom v-if="editMode">
          <template v-slot:activator="{ on }">
            <v-btn small icon v-on="on" @click="addMyMenu"><v-icon x-small color="white">mdi-plus</v-icon> </v-btn>
          </template>
          <span>추가 (자동저장)</span>
        </v-tooltip>
        <v-tooltip bottom v-if="editMode">
          <template v-slot:activator="{ on }">
            <v-btn small icon v-on="on" @click="deleteMyMenu"><v-icon x-small color="white">mdi-minus</v-icon> </v-btn>
          </template>
          <span>삭제</span>
        </v-tooltip>
        <v-tooltip bottom v-if="editMode">
          <template v-slot:activator="{ on }">
            <v-btn small icon v-on="on" @click="modifyMyMenuName"><v-icon x-small color="white">mdi-pencil-outline</v-icon> </v-btn>
          </template>
          <span>변경</span>
        </v-tooltip>
        <v-tooltip bottom v-if="editMode">
          <template v-slot:activator="{ on }">
            <v-btn small icon v-on="on" @click="saveMyMenu"><v-icon x-small color="white">mdi-check</v-icon> </v-btn>
          </template>
          <span>저장</span>
        </v-tooltip>
      </v-card-actions>
      <v-card-text>
        <div ref="menuTree" class="bookmark_container"></div>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import Message from '@/utils/message'
import { saveMyMenu } from '@/api/common/user'
import { getScrollOption } from '@/utils/scroll'
import store from '@/store'
require('@/assets/theme/proton/style.min.css')
require('jstree')

export default {
  name: 'BookMark',
  data() {
    return {
      jstreeData: [], // jstree 에 필요한 데이터셋
      jstreeObj: null,
      temps: [],
      // 즐겨찾기 사이드 메뉴 영역 스타일
      bookMarkOps: {},
      editButton: true,
      editMode: false,
      editPopup: false,
      selectNode: '',
      drawerRight: ''
    }
  },
  created() {
    this.scrollOps()
  },
  mounted() {
  },
  computed: {
    // 사이드바 고정시 감싸고 있는 부모에 가로값 적용 부분
    bookMarkWidthClass() {
      return this.$store.state.menu.flag.myMenuVisible === false
        ? ''
        : 'bookmark_box_width'
    },
    drawer: {
      get() {
        return store.state.menu.flag.bookMarkDrawer
      },
      set(val) {
        store.dispatch('SetBookmarkDrawer', val)
      }
    }
  },
  watch: {
    '$store.state.user.myMenu'(newVal) {
      this.retrieve(newVal)
    },
    drawer(newVal) {
      if (newVal) {
        this.retrieve()
      }
    }
  },
  methods: {
    retrieve(treeData) {
      let setTree = menuData => {
        if (this.jstreeObj) this.jstreeObj.jstree(true).destroy() // 트리가 존재하면 트리 삭제
        this.initTree() // 트리 재설정
        this.setTreeMenu(menuData) // 새로운 메뉴 값으로 메뉴 그려줌
        this.setTreeClickEvent() // 트리가 그려진 후 tree 클릭 이벤트 셋팅
        this.setMoveNodeEvent()
      }

      if (!treeData) {
        this.$store
          .dispatch('GetMyMenu', this.$store.state.user.userId)
          .then(() => {
            setTree(this.$store.state.user.myMenu) // 새로운 메뉴 값으로 메뉴 그려줌
          })
      } else {
        setTree(treeData)
      }
    },
    initTree() {
      // Tree instance를 생성한다.
      this.jstreeObj = $(this.$refs.menuTree).jstree({
        core: {
          check_callback: (e, node, parent) => {
            if (e === 'move_node') {
              if (this.editMode) {
                // 노드 이동시 이벤트
                if (
                  parent.data &&
                  parent.data.node_type &&
                  parent.data.node_type === 'F'
                ) {
                  // node_type 이 F 인 노드의 하위로만 이동 가능하다
                  return true
                } else return false
              } else {
                return false
              }
            } else {
              return true
            }
          },
          data: this.jstreeData,
          themes: {
            // 테마 적용
            name: 'proton',
            responsive: false,
            icons: true // 아이콘 사용함
          }
        },
        checkbox: {
          visible: false, // checkbox 최초 조회시에는 보이지 않게
          keep_selected_style: false, // 선택된 노드들 남아있는 것 남아있지 않게 처리
          // select_node 와 check_node 를 분리하기 위한 옵션 값으로 두가지 다 들어가야 합니다
          whole_node: false,
          tie_selection: false
        },
        // type 에 따라 아이콘 class 분리
        types: {
          F: {
            icon: 'far fa-folder-open text-white tree_icon_size'
          },
          M: {
            icon: 'far fa-file text-white tree_icon_size'
          }
        },
        plugins: ['checkbox', 'dnd', 'types'] // 체크박스, drag&drop, 수정 사용
      })
    },
    // jstree 셋팅
    setTreeMenu(menuData) {
      var treeNode = this.jstreeObj.jstree(true)
      this.jstreeData = []
      menuData.forEach(menuItem => {
        this.jstreeData.push({
          id: menuItem.mymenu_id,
          text: menuItem.mymenu_nme,
          parent: menuItem.prnts_mymenu_id,
          data: menuItem,
          type: menuItem.node_type // 아이콘 셋팅을 위한 값 셋팅
        })
      })
      treeNode.settings.core.data = this.jstreeData
      treeNode.refresh()
    },
    // jstree 노드 클릭 이벤트 셋팅
    setTreeClickEvent() {
      this.jstreeObj.on('select_node.jstree', (e, selectNode) => {
        this.selectNode = selectNode.node
        // 노드 선택시 이벤트
        if (!this.editMode) {
          // ID 를 가진 메뉴만 라우터로 이동 가능하다
          if (this.selectNode.data.node_type === 'M') {
            this.$router.push(this.selectNode.data.href) // 선택된 노드의 href 값으로 보내준다.
          }
        }
      })
    },
    // jstree 노드 이동 시 호출되는 이벤트 셋팅
    setMoveNodeEvent() {
      this.jstreeObj.on('move_node.jstree', (e, moveNodeInstance) => {
        let moveNode = moveNodeInstance.node
        let newParentId = moveNodeInstance.node.parent
        let parentNode = this.jstreeObj.jstree(true).get_node(newParentId)
        // 옮긴 노드에 대한 부모 아이디 셋팅
        moveNode.data.prnts_mymenu_id = parentNode.id
        // 1레벨 메뉴일 경우
        if (parentNode.id === '#') {
          // 메뉴 레벨 셋팅
          moveNode.data.menulevel = 1
        } else {
          // 그 이외의 경우에는 부모 노드 레벨 + 1
          moveNode.data.menulevel = parentNode.data.menulevel + 1
        }
        // 이동된 노드의 정렬 순서는 0 번이다
        moveNode.data.mnu_seq = 0
        if (parentNode.children.length > 1) {
          for (let i = 0; i < parentNode.children.length; i++) {
            // get_json 으로 가져오면 값 변경했을 때 반영이 되지 않아서 각 노드 ID 넣어서 노드 데이터 가져옴
            let sameLevelNode = this.jstreeObj
              .jstree(true)
              .get_node(parentNode.children[i])
            sameLevelNode.data.mnu_seq = i // 순서대로 mnu_seq 업데이트
            if (!sameLevelNode.data.node_status) {
              // node_status 값이 없으면 update 셋팅
              sameLevelNode.data['node_status'] = 'updated'
            }
          }
        }
        // node_status 값이 없을 경우에만 updated 셋팅
        if (!moveNode.data.node_status) moveNode.data.node_status = 'updated'
        // 자식 노드가 있을 경우
        if (moveNode.children.length > 0) {
          // 자식 노드에 대한 level, status 셋팅
          this.childNodeSet(moveNode.children, moveNode.data.menulevel)
        }
      })
    },
    // 자식 노드들에 대한 데이터 셋팅
    childNodeSet(nodeData, level) {
      nodeData.forEach(nodeId => {
        // nodeId 를 통해 자식 노드 데이터를 가져온다
        let node = this.jstreeObj.jstree(true).get_node(nodeId)
        // 부모 노드 레벨 + 1
        node.data.menulevel = level + 1
        // node_statue 가 없는 경우에만 updated 셋팅
        if (!node.data.node_status) node.data.node_status = 'updated'
        // 자식 노드가 존재할 때
        if (node.children.length > 0) {
          // 자식 노드에 대한 데이터 셋팅
          this.childNodeSet(node.children, node.data.menulevel)
        }
      })
    },
    // 편집버튼을 클릭했을 때 삭제버튼 노출 여부
    editBookMarkMenu() {
      this.editMode = !this.editMode
      // editMode 가 종료될 시점에 재조회 (편집중이던 내용 날림)
      if (!this.editMode) {
        this.retrieve()
      } else {
        // editMode 가 시작될 시점에 checkBox 셋팅
        this.setCheckBox()
      }
    },
    // 체크박스 셋팅 이벤트
    setCheckBox() {
      // editMode 일 떄마
      if (this.editMode) {
        // 체크박스 보이게 처리
        this.jstreeObj.jstree(true).show_checkboxes()
        this.jstreeObj.jstree(true).uncheck_all() // 삭제 성공 후 전체 체크 해제
      }
    },
    // 마이메뉴 추가 (무조건 1레벨에 추가)
    addMyMenu() {
      if (this.editMode) {
        let treeAllData = this.jstreeObj.jstree(true).get_json('#')
        let menuSeq = treeAllData.length
        this.jstreeObj.jstree('create_node', '#', {
          text: '새폴더',
          parent: '#',
          type: 'F',
          data: {
            mymenu_nme: '새폴더',
            node_type: 'F',
            mnu_seq: menuSeq,
            prnts_mymenu_id: '#',
            node_status: 'created', // 저장시 사용할 상태값 업데이트
            menulevel: 1
          }
        })
        this.saveMyMenu()
      }
    },
    // 마이메뉴 삭제
    deleteMyMenu() {
      var messageOption = ''
      var checkedNodeList = this.jstreeObj.jstree(true).get_checked(true)
      if (checkedNodeList && checkedNodeList.length > 0) {
        var treeSaveData = {
          deleted: [],
          retrieveData: { userId: this.$store.state.user.userId }
        }
        // 체크된 노드 검사
        checkedNodeList.forEach(nodeData => {
          // 신규 노드일 경우
          if (nodeData.data.node_status === 'created') {
            // 바로 삭제
            this.jstreeObj.jstree(true).delete_node(nodeData.id)
          } else {
            // 기존 노드일 경우
            // 삭제를 위한 데이터 셋팅
            treeSaveData.deleted.push(nodeData.data)
          }
        })
        // 저장 API 호출
        saveMyMenu(treeSaveData)
          .then(res => {
            Message.success('즐겨찾기 삭제가 완료되었습니다.') // 메시지 처리
            this.editBookMarkMenu()
          })
          .catch(() => {
            Message.err('즐겨찾기 삭제에 실패하였습니다. 잠시 후 다시 시도해주세요.') // 삭제 실패시 메시지
          })
      } else {
        messageOption = { contents: '선택된 노드가 없습니다.', color: 'warning' }
        this.$store.dispatch('SetMessageOption', messageOption)
        this.$store.dispatch('SetShowMessage', true)

        // Message.warn('선택된 노드가 없습니다.') // 선택된 노드 없으면 삭제 메시지 처리
      }
    },
    // 마이메뉴의 name 을 수정한다
    modifyMyMenuName() {
      // 수정 모드일 때만 수정 가능
      if (this.editMode) {
        // node_type 이 F 인 경우에만 수정 가능(기존 메뉴 수정 불가능)
        if (this.selectNode.data.node_type === 'F') {
          // edit 이벤트 처리
          this.jstreeObj.jstree(
            'edit',
            this.selectNode.id, // 선택된 node Id
            this.selectNode.text, // 선택된 node의 text 값
            nodeNewVal => {
              // 변경된 데이터를 data 내부에 반영(실제 데이터)
              nodeNewVal.data.mymenu_nme = nodeNewVal.text
              // 수정이 끝나고 난 후 실행될 callback 함수
              // node_status 값이 없는 경우에만 updated 처리함
              // 있는경우는 created 혹은 updated 가 이미 셋팅된 경우이기 때문
              if (!nodeNewVal.data.node_status) {
                nodeNewVal.data['node_status'] = 'updated' // 저장시 활용하기 위한 상태값 업데이트
              }
            }
          )
        }
      }
    },
    // 마이메뉴 수정 사항을 저장한다 (추가 및 수정)
    saveMyMenu() {
      if (this.editMode) {
        // 트리 전체 데이터 가져옴
        let treeAllData = this.jstreeObj.jstree(true).get_json('#')
        // 저장 틀을 만들기 위한 함수를 호출한다
        let treeSaveData = this.setSaveTreeData(treeAllData)
        // 저장 및 재조회
        saveMyMenu(treeSaveData)
          .then(res => {
            Message.success('즐겨찾기 저장이 완료되었습니다.') // 메시지 처리
            this.editBookMarkMenu()
          })
          .catch(() => {
            Message.err('즐겨찾기 저장에 실패하였습니다. 잠시 후 다시 시도해주세요.') // 저장 실패 시 메시지
          })
      }
    },
    // 트리 저장을 위한 데이터 셋팅
    setSaveTreeData(treeData, targetObj) {
      if (!targetObj) {
        targetObj = {
          created: [],
          updated: [],
          retrieveData: { userId: this.$store.state.user.userId }
        }
      }
      treeData.forEach(node => {
        // 추가 노드일 경우
        if (node.data.node_status === 'created') {
          // 추가할 데이터 셋팅
          targetObj.created.push(node.data)
        } else if (node.data.node_status === 'updated') {
          // 수정 노드일 경우
          // 수정할 노드 셋팅
          targetObj.updated.push(node.data)
        }
        // 자식 노드가 있을 때
        if (node.children.length > 0) {
          // 자식 노드에 대한 데이터 셋팅
          this.setSaveTreeData(node.children, targetObj)
        }
      })
      return targetObj
    },
    scrollOps() {
      this.bookMarkOps = getScrollOption()
    }
  },
  beforeDestroy() {
    if (this.jstreeObj) this.jstreeObj.jstree(true).destroy()
  }
}
</script>

<style lang="scss">
.bookmark_container {
  color: #fff;
  font-size: 12px;
  .jstree-children{
    padding-left: 0 !important;
  }
}
</style>
